export const ASPECT_RATIOS = {
  ORIGINAL: 'original',
  RATIO_1_1: '1:1',
  RATIO_16_9: '16:9',
  RATIO_9_16: '9:16',
  RATIO_4_5: '4:5',
  RATIO_3_4: '3:4',
};

export const ASPECT_RATIO_OPTIONS = [
  ASPECT_RATIOS.ORIGINAL,
  ASPECT_RATIOS.RATIO_1_1,
  ASPECT_RATIOS.RATIO_16_9,
  ASPECT_RATIOS.RATIO_9_16,
  ASPECT_RATIOS.RATIO_4_5,
  ASPECT_RATIOS.RATIO_3_4,
];

export const getAspectRatioValue = (ratio) => {
  if (!ratio || ratio === ASPECT_RATIOS.ORIGINAL) {
    return null;
  }

  const [widthPart, heightPart] = String(ratio).split(':');
  const width = Number(widthPart);
  const height = Number(heightPart);

  if (!Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0) {
    return null;
  }

  return width / height;
};

export const getInitialCropRect = (stageWidth, stageHeight, ratioKey) => {
  const aspectRatio = getAspectRatioValue(ratioKey);

  if (!stageWidth || !stageHeight) {
    return { x: 0, y: 0, width: 0, height: 0 };
  }

  if (!aspectRatio) {
    return { x: 0, y: 0, width: stageWidth, height: stageHeight };
  }

  let width;
  let height;

  if (stageWidth / stageHeight > aspectRatio) {
    height = stageHeight;
    width = height * aspectRatio;
  } else {
    width = stageWidth;
    height = width / aspectRatio;
  }

  width = Math.min(width, stageWidth);
  height = Math.min(height, stageHeight);

  return {
    x: (stageWidth - width) / 2,
    y: (stageHeight - height) / 2,
    width,
    height,
  };
};
